import { ApiMethod } from '@wajeez-web/stores/base';
import { AlertType, CommonActions } from '@wajeez-web/stores/common';
import { paymentClient, Server } from '@wajeez-web/core/api-base';
import {
  thunkErrorHandler,
  thunkResponseCheckerSdk,
} from '@wajeez-web/core/utils';

export const getPromoCodeAliasesDatatable: ApiMethod<
  Server.PromoCodeAliasDataTableInput,
  Server.TableOfPromoCodeAliasColumns,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PromoCodeAlias_Client(
      undefined,
      paymentClient
    );

    const response = await client.promoCodeAlias_datatable_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getPromoCodeAliasById: ApiMethod<
  number,
  Server.PromoCodeAliasOutput,
  void
> = async (id, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PromoCodeAlias_Client(
      undefined,
      paymentClient
    );

    const response = await client.promoCodeAlias_byId_get_V1(id);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const createPromoCodeAlias: ApiMethod<
  Server.CreatePromoCodeAliasInput,
  Server.PromoCodeAliasOutput,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PromoCodeAlias_Client(
      undefined,
      paymentClient
    );

    const response = await client.promoCodeAlias_post_V1(data);

    if (response.success && response.data) {
      return response.data;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const editPromoCodeAlias: ApiMethod<
  Server.EditPromoCodeAliasInput,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PromoCodeAlias_Client(
      undefined,
      paymentClient
    );

    const response = await client.promoCodeAlias_update_put_V1(data);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const changePromoCodeAliasPublicationStatus: ApiMethod<
  Server.PromoCodeAliasPublicationInput,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  try {
    const client = new Server.Server_PromoCodeAlias_Client(
      undefined,
      paymentClient
    );

    const response = await client.promoCodeAlias_publication_put_V1(data);

    if (response.success) {
      return;
    }

    return rejectWithValue(response.errors);
  } catch (error: any) {
    const errors = JSON.parse(error.response).errors;

    dispatch(
      CommonActions.setAlert({
        show: true,
        type: AlertType.ERROR,
        messages: errors || [{ message: 'Something went wrong' }],
      })
    );

    return rejectWithValue(errors);
  }
};

export const getPromoCodeAliasesLookups: ApiMethod<
  void,
  Server.PromoCodeAliasDetailOutput[],
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Server.Server_PromoCodeAlias_Client(
          undefined,
          paymentClient
        );

        const response = await client.promoCodeAlias_lookups_get_V1();

        return response;
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue
  );
};
